import * as React from 'react';
import { connect } from 'react-redux';
import isNil from 'lodash/isNil';

import BaseCcmCampaignPage from '../../BaseCcmCampaignPage';
import CcmCampaignReporting from 'modules/campaigns/components/ccm/components/reporting/CcmCampaignReporting';

import {
  fetchCcmOutfitPerformance,
  updateOutfitPerformanceCountries
} from 'modules/campaigns/components/ccm/redux/actions';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./ccm-campaign-report-page.i18n.json'));

import type {
  Campaign,
  LocationWindow,
  MixedSelectDropdownItem,
  Params
} from 'types';
import type {
  CcmCampaignReportingOutfitPerformance
} from 'modules/campaigns/components/ccm/types/CcmCampaignReporting.type';

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign,
  outfitPerformance: CcmCampaignReportingOutfitPerformance | null,
  outfitPerformanceCountries: Array<MixedSelectDropdownItem>,
  location: LocationWindow
};

type DispatchProps = {
  dispatchFetchOutfitPerformance: (
    campaignId: number,
    countries: Array<MixedSelectDropdownItem>
  ) => Promise<void>,
  dispatchUpdateOutfitPerformanceCountries: (
    outfitPerformanceCountries: Array<MixedSelectDropdownItem>
  ) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const MSG_KEY = 'ccm_campaign_report_page';

const CcmCampaignReportPage: React.FC<Props> = ({
  params,
  location,
  campaign,
  outfitPerformance,
  outfitPerformanceCountries,
  dispatchFetchOutfitPerformance,
  dispatchUpdateOutfitPerformanceCountries
}): JSX.Element => {
  const handleFetchOutfitPerformance = (
    countries: Array<MixedSelectDropdownItem>
  ): void => {
    dispatchFetchOutfitPerformance(campaign.id, countries);
  };

  React.useEffect(() => {
    if (!isNil(campaign.id)) {
      handleFetchOutfitPerformance([]);
    }
  }, [campaign.id]);

  return (
    <div className="ccm-campaign-report-page">
      <BaseCcmCampaignPage
        campaignType={campaign.campaignType ?? 'ccm'}
        params={params}
        documentTitle={__t(`${MSG_KEY}.document_title`)}
        pageType="report"
        childrenClassName="ccm-campaign-overview-page__base"
      >
        <CcmCampaignReporting
          campaign={campaign}
          outfitPerformance={outfitPerformance}
          outfitPerformanceCountries={outfitPerformanceCountries}
          location={location}
          dispatchFetchOutfitPerformance={dispatchFetchOutfitPerformance}
          dispatchUpdateOutfitPerformanceCountries={dispatchUpdateOutfitPerformanceCountries}
        />
      </BaseCcmCampaignPage>
    </div>
  );
};

const mapStateToProps = ({
  campaignBrief,
  ccmCampaign,
  router
}): StateProps => ({
  campaign: campaignBrief.brief,
  outfitPerformance: ccmCampaign.outfitPerformance,
  outfitPerformanceCountries: ccmCampaign.outfitPerformanceCountries,
  location: router.location
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchOutfitPerformance: (
    campaignId: number,
    countries: Array<MixedSelectDropdownItem>
  ) => (
    dispatch(fetchCcmOutfitPerformance(campaignId, countries))
  ),
  dispatchUpdateOutfitPerformanceCountries: (
    outfitPerformanceCountries: Array<MixedSelectDropdownItem>
  ) => (
    dispatch(updateOutfitPerformanceCountries(outfitPerformanceCountries))
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(CcmCampaignReportPage);
